// This file was automatically generated from mindreader.html.
// Please don't edit this file by hand.

goog.provide('el8.template.mindreader');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.physicians');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.physicianMedGroup = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div>');
  if (opt_data.item.rank_in_canonical_group == null || opt_data.item.header_in_canonical_group) {
    output.append('<div class="el8MRProfileWrap ', (opt_data.item.header_in_canonical_group) ? 'el8MRProfileGroupHeader' : '', '">');
    el8.template.data.physicians.icon({accessUserId: opt_data.item.public_access_user_id, providerLogo: opt_data.item.provider_logo, isOrg: opt_data.item.is_org, isNotMapped: opt_data.item.is_not_mapped, isActivePlr: opt_data.item.isActivePlr, isSharingPlr: opt_data.item.isSharingPlr, isInvitePendingPlr: opt_data.item.isIvitePendingPlr}, output);
    output.append('<span class="el8MRProfileName">', soy.$$escapeHtml(opt_data.item.name), (opt_data.item.practicing_status == 'retired') ? ' (retired)' : '', '</span>');
    if (opt_data.item.is_e_confirmed) {
      el8.template.data.physicians.verifiedCheck(null, output);
    }
    if (opt_data.item.rank_in_canonical_group == null) {
      el8.template.mindreader.patientsInCommon({item: opt_data.item}, output);
    }
    if (opt_data.item.specialties && opt_data.item.specialties.length) {
      output.append('<div class="el8MRDetails el8ItalicText">');
      el8.template.util.format.commaSeparate({list: opt_data.item.specialties}, output);
      output.append('</div>');
    }
    output.append((opt_data.item.header_in_canonical_group) ? '<div class="el8MRDetails">At multiple locations:</div>' : ((opt_data.item.address) ? '<div class="el8MRDetails">' + soy.$$escapeHtml(opt_data.item.address) + '</div>' : '') + ((opt_data.item.fax) ? '<div class="el8MRDetails">Fax: ' + soy.$$escapeHtml(opt_data.item.fax) + '</div>' : '') + ((opt_data.item.direct_address) ? '<div class="el8MRDetails">Direct Address: ' + soy.$$escapeHtml(opt_data.item.direct_address) + '</div>' : '') + ((opt_data.item.email) ? '<div class="el8MRDetails">Email: ' + soy.$$escapeHtml(opt_data.item.email) + '</div>' : ''), '</div>');
  }
  if (opt_data.item.rank_in_canonical_group != null) {
    output.append('<div class="el8MRProfileWrap ', (opt_data.item.footer_in_canonical_group) ? 'el8MRProfileGroupFooter' : 'el8MRProfileGroupEntry', '"><div class="el8MRDetails"><span class="el8Bold">', soy.$$escapeHtml(opt_data.item.practice_name), '</span>');
    el8.template.mindreader.patientsInCommon({item: opt_data.item}, output);
    output.append('</div>', (opt_data.item.address) ? '<div class="el8MRDetails">' + soy.$$escapeHtml(opt_data.item.address) + '</div>' : '', '<div class="el8MRProfileGroupPhotoBlank">&nbsp;</div></div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.patientsInCommon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((el8Globals.FEATURES.ProvidersNetwork && opt_data.item.num_teams_participated != null) ? '<span class="padl5 el8MRDetails">&mdash; ' + soy.$$escapeHtml(opt_data.item.num_teams_participated) + ' patient' + ((opt_data.item.num_teams_participated != 1) ? 's' : '') + ' in common</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.consultantAddress = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="contactName">', (opt_data.specialtyName) ? soy.$$escapeHtml(opt_data.fullName) + ', ' + soy.$$escapeHtml(opt_data.specialtyName) : soy.$$escapeHtml(opt_data.fullName), '</p>', (opt_data.addressLine || opt_data.cityStateZip) ? '<p class="contactDetails">' + soy.$$escapeHtml(opt_data.addressLine) + ((opt_data.addressLine) ? ' ' : '') + soy.$$escapeHtml(opt_data.cityStateZip) + '</p>' : '', (opt_data.phone || opt_data.fax || opt_data.email) ? '<p class="contactDetails">' + ((opt_data.phone) ? 'T: ' + soy.$$escapeHtml(opt_data.phone) + ((opt_data.fax || opt_data.email) ? ', ' : '') : '') + ((opt_data.fax) ? 'F: ' + soy.$$escapeHtml(opt_data.fax) + ((opt_data.email) ? ', ' : '') : '') + ((opt_data.email) ? 'E: ' + soy.$$escapeHtml(opt_data.email) : '') + '</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.medication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', (opt_data.item.name && el8Globals.FEATURES.MedOrderTemplates) ? '<div class="el8Row"><div class="el8Col10"><div class="mb5 padr5">' + soy.$$escapeHtml(opt_data.item.name) + '</div><div class="el8MRDetails padr5">' + ((opt_data.item.directions) ? soy.$$escapeHtml(opt_data.item.directions) + ' ' : '') + ((opt_data.item.qty) ? '#' + soy.$$escapeHtml(opt_data.item.qty) + ' ' : '') + ((opt_data.item.qtyUnits) ? soy.$$escapeHtml(opt_data.item.qtyUnits) + ' ' : '') + ((opt_data.item.authRefills) ? 'RFx' + soy.$$escapeHtml(opt_data.item.authRefills) + ' ' : 'RFx0') + '</div></div><div class="el8Col2 el8AlignRight padt4"><span class="el8TagItem mr5">Rx Template</span></div></div>' : soy.$$escapeHtml(opt_data.item.brandName) + ((opt_data.item.strength) ? ' ' + soy.$$escapeHtml(opt_data.item.strength) : '') + ((opt_data.item.form) ? ' <span class="el8ItemSmallText">' + soy.$$escapeHtml(opt_data.item.form) + '</span>' : '') + '<span class="el8MRTagContainer">' + ((opt_data.item.isControlled) ? '<span class="el8TagItem mr5">Controlled</span>' : (opt_data.item.isDispensable) ? '<span class="el8TagItem mr5">Dispensable</span>' : (opt_data.item.type) ? (opt_data.item.type == 'prescription') ? '<span class="el8TagItem mr5">Rx</span>' : (opt_data.item.type == 'otc') ? '<span class="el8TagItem mr5">OTC</span>' : '' : '') + ((opt_data.item.isUserCreated) ? '<span class="el8TagItem mr5">User</span>' : '') + '</span><div class="el8MRDetails">' + ((opt_data.item.genericName) ? soy.$$escapeHtml(opt_data.item.genericName) : 'Generic name not available') + '</div>', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.pharmacy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (el8Globals.FEATURES.MDToolboxEPCS) {
    output.append('<div class="el8MRItemWrap padr40 el8Medium">', soy.$$escapeHtml(opt_data.item.store_name), ' </div><div class="el8MRDetails">', soy.$$escapeHtml(opt_data.item.address), ', ', soy.$$escapeHtml(opt_data.item.city), ', ', soy.$$escapeHtml(opt_data.item.state), ' ', soy.$$escapeHtml(opt_data.item.zip), '</div>', (opt_data.item.supports_controlled_substance) ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5 mt10">EPCS</span></span>' : '', '<div class="el8MRDetails">');
    if (opt_data.item.specialty_types) {
      var specialtyTypeList11174 = opt_data.item.specialty_types;
      var specialtyTypeListLen11174 = specialtyTypeList11174.length;
      for (var specialtyTypeIndex11174 = 0; specialtyTypeIndex11174 < specialtyTypeListLen11174; specialtyTypeIndex11174++) {
        var specialtyTypeData11174 = specialtyTypeList11174[specialtyTypeIndex11174];
        output.append((specialtyTypeData11174 != 'Retail') ? soy.$$escapeHtml(specialtyTypeData11174) + '   ' : '');
      }
    }
    output.append('</div><div class="el8MRDetails">Tel: ', (opt_data.item.phone) ? soy.$$escapeHtml(opt_data.item.phone) : 'N/A', ', Fax: ', (opt_data.item.fax) ? soy.$$escapeHtml(opt_data.item.fax) : 'N/A', '</div>');
  } else {
    output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.store_name), ' <span class="el8ItemSmallText">', soy.$$escapeHtml(opt_data.item.address), ', ', soy.$$escapeHtml(opt_data.item.city), ', ', soy.$$escapeHtml(opt_data.item.state), ' ', soy.$$escapeHtml(opt_data.item.zip), '</span></div><div class="el8MRDetails">');
    if (opt_data.item.specialty_types) {
      var specialtyTypeList11207 = opt_data.item.specialty_types;
      var specialtyTypeListLen11207 = specialtyTypeList11207.length;
      for (var specialtyTypeIndex11207 = 0; specialtyTypeIndex11207 < specialtyTypeListLen11207; specialtyTypeIndex11207++) {
        var specialtyTypeData11207 = specialtyTypeList11207[specialtyTypeIndex11207];
        output.append(soy.$$escapeHtml(specialtyTypeData11207), '   ');
      }
    }
    output.append('</div><div class="el8MRDetails">Tel: ', (opt_data.item.phone) ? soy.$$escapeHtml(opt_data.item.phone) : 'N/A', ', Fax: ', (opt_data.item.fax) ? soy.$$escapeHtml(opt_data.item.fax) : 'N/A', '</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.patient = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', (opt_data.isSelf) ? '<span class="el8NewChartItem">this chart</span>' : '', (el8Globals.FEATURES.PatientStatus && opt_data.item.patient_status && opt_data.item.patient_status != 'Active') ? '<span class="el8Badge warning mr5">' + soy.$$escapeHtml(opt_data.item.patient_status) + '</span>' : '', (opt_data.item.is_vip) ? '<span class="el8Badge critical mr5">VIP</span>' : '', soy.$$escapeHtml(opt_data.item.name), ' <span class="el8ItemSmallText">(', (opt_data.item.sex) ? soy.$$escapeHtml(opt_data.item.sex) : 'U', ')</span>');
  if (opt_data.item.tags && opt_data.item.tags.length) {
    output.append('<span class="el8MRTagContainer">');
    var tList11248 = opt_data.item.tags;
    var tListLen11248 = tList11248.length;
    for (var tIndex11248 = 0; tIndex11248 < tListLen11248; tIndex11248++) {
      var tData11248 = tList11248[tIndex11248];
      output.append('<span class="el8TagItem mr5">', soy.$$escapeHtml(tData11248), '</span>');
    }
    output.append('</span>');
  }
  output.append('</div><div class="el8MRDetails">DOB: ', (opt_data.item.dob) ? soy.$$escapeHtml(opt_data.item.dob) : 'n/a', ', ', (opt_data.item.last_seen) ? 'Last Seen: ' + soy.$$escapeHtml(opt_data.item.last_seen) + ', ' : '', (opt_data.item.next_appt) ? 'Next Appt: ' + soy.$$escapeHtml(opt_data.item.next_appt) + ', ' : '', 'Attributed to: ', (opt_data.item.primaryPhysicianName) ? soy.$$escapeHtml(opt_data.item.primaryPhysicianName) : 'n/a', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.icd9 = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.code), (opt_data.item.description) ? ' - <span class="el8AppColor">' + soy.$$escapeHtml(opt_data.item.description) + '</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.snomedAwareIcd9 = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.code), (opt_data.item.description) ? ' - <span class="el8AppColor">' + soy.$$escapeHtml(opt_data.item.description) + '</span>' : '', (opt_data.item.mapped_snomed) ? '<span class="el8TagItem el8SnomedTag ml5">+SNOMED</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.snomed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.snomed), (opt_data.item.snomed_description) ? ' - <span class="el8AppColor">' + soy.$$escapeHtml(opt_data.item.snomed_description) + '</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.legacySnomed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.code), (opt_data.item.description) ? ' - <span class="el8AppColor">' + soy.$$escapeHtml(opt_data.item.description) + '</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.allergy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.name), (opt_data.item.is_user_created) ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5">User</span></span>' : '', (opt_data.item.type == 'allergenClass') ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5">Allergen</span></span>' : '', (opt_data.item.type == 'ingredient') ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5">Ingredient</span></span>' : '', (opt_data.item.type == 'drugName') ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5">Drug Name</span></span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.labOrderSet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrapFlex"><div class="maincolumn"><div>', soy.$$escapeHtml(opt_data.item.name), '</div>');
  if (opt_data.item.test_names) {
    output.append('<div class="el8MRDetails">Tests include ');
    var tList11340 = opt_data.item.test_names;
    var tListLen11340 = tList11340.length;
    for (var tIndex11340 = 0; tIndex11340 < tListLen11340; tIndex11340++) {
      var tData11340 = tList11340[tIndex11340];
      output.append((tIndex11340 == tListLen11340 - 1) ? (opt_data.item.test_names.length > 1) ? 'and  ' + soy.$$escapeHtml(tData11340) : ' ' + soy.$$escapeHtml(tData11340) : soy.$$escapeHtml(tData11340) + ', ');
    }
    output.append('</div>');
  }
  output.append('</div><div class="tagscolumn"><div class="el8TagItem">Order Set</div>', (opt_data.item.vendor_display_name) ? '<div class="el8TagItem">' + soy.$$escapeHtml(opt_data.item.vendor_display_name) + '</div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.labOrderTest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrapFlex"><div class="maincolumn">', soy.$$escapeHtml(opt_data.item.name), (opt_data.item.code) ? ' (' + soy.$$escapeHtml(opt_data.item.code) + ')' : '', '</div><div class="tagscolumn">', (opt_data.item.is_user_created && ! opt_data.item.compendium_id) ? '<div class="el8TagItem">User</div>' : '', (opt_data.item.vendor_name) ? '<div class="el8TagItem">' + ((opt_data.item.vendor_name == 'care360') ? 'Quest' : soy.$$escapeHtml(opt_data.item.vendor_name)) + '</div>' : '', '</div></div>');
  if (opt_data.item.synonyms && opt_data.item.synonyms.length) {
    output.append('<div class="el8MRDetails">Synonyms: ');
    var sList11387 = opt_data.item.synonyms;
    var sListLen11387 = sList11387.length;
    for (var sIndex11387 = 0; sIndex11387 < sListLen11387; sIndex11387++) {
      var sData11387 = sList11387[sIndex11387];
      output.append((sIndex11387 == sListLen11387 - 1) ? ((opt_data.item.synonyms.length > 1) ? 'and ' : '') + soy.$$escapeHtml(sData11387) : soy.$$escapeHtml(sData11387) + ', ');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.intolerance = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ItemWrap">', soy.$$escapeHtml(opt_data.item.name), (opt_data.item.is_user_created) ? '<span class="el8MRTagContainer"><span class="el8TagItem mr5">User</span></span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.commonVaccine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.packaged_name), (opt_data.item.display_dose || opt_data.item.route) ? ' <span class="el8MRItemSmallText">' + ((opt_data.item.display_dose) ? soy.$$escapeHtml(opt_data.item.display_dose) + ' ' : '') + ((opt_data.item.route) ? soy.$$escapeHtml(opt_data.item.route) : '') + '</span>' : '', '</div><div class="el8MRDetails">', (opt_data.item.cdc_name) ? soy.$$escapeHtml(opt_data.item.cdc_name) + ' ' : '', '(', soy.$$escapeHtml(opt_data.item.cdc_type), ')', (opt_data.item.manuf_name) ? ', ' + soy.$$escapeHtml(opt_data.item.manuf_name) : '', (opt_data.item.cvx) ? ' CVX ' + soy.$$escapeHtml(opt_data.item.cvx) : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.otherVaccine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.item.packaged_name) ? '<div class="el8MRItemWrap">' + soy.$$escapeHtml(opt_data.item.packaged_name) + ' <span class="el8MRItemSmallText">' + soy.$$escapeHtml(opt_data.item.name) + ((opt_data.item.route) ? ' ' + soy.$$escapeHtml(opt_data.item.route) : '') + '</span></div>' + ((opt_data.item.manuf_name || opt_data.item.cvx) ? '<div class="el8MRDetails">' + ((opt_data.item.manuf_name) ? soy.$$escapeHtml(opt_data.item.manuf_name) : '') + ((opt_data.item.cvx) ? ' CVX ' + soy.$$escapeHtml(opt_data.item.cvx) : '') + '</div>' : '') : '<div class="el8MRItemWrap">' + soy.$$escapeHtml(opt_data.item.name) + '</div>' + ((opt_data.item.cvx) ? '<div class="el8MRDetails">' + ((opt_data.item.cvx) ? 'CVX ' + soy.$$escapeHtml(opt_data.item.cvx) : '') + '</div>' : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.ancillaryTest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.item.name));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.specialty = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.name), '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.cptCode = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.code), (opt_data.item.description) ? ' - ' + soy.$$escapeHtml(opt_data.item.description) : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.codedDocumentTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap"><div class="mt2">', soy.$$escapeHtml(opt_data.item.value), '</div><span class="el8MRTagContainer">', (opt_data.item.is_cpcplus && el8Globals.FEATURES.CQMsForCPCPlus) ? '<span class="el8MUTag el8TagItem">CPC+</span>' : (opt_data.item.is_mips) ? '<span class="el8MUTag el8TagItem">MIPS</span>' : '', '</span>', (opt_data.item.code || opt_data.item.description) ? '<div class="el8MRDetails mt3 mb2">' + ((opt_data.item.code) ? soy.$$escapeHtml(opt_data.item.code) + ((opt_data.item.code_type) ? ' (' + soy.$$escapeHtml(opt_data.item.code_type) + ')' : '') : '') + ((opt_data.item.description) ? ((opt_data.item.code) ? ' - ' : '') + soy.$$escapeHtml(opt_data.item.description) : '') + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.cmsPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', (opt_data.item.is_org) ? soy.$$escapeHtml(opt_data.item.name) + '<span class="el8MRTagContainer"><span class="el8TagItem">Organization</span></span>' : soy.$$escapeHtml(opt_data.item.first_name) + ((opt_data.item.middle_name) ? ' ' + soy.$$escapeHtml(opt_data.item.middle_name) : '') + ' ' + soy.$$escapeHtml(opt_data.item.last_name) + ((opt_data.item.suffix) ? ' ' + soy.$$escapeHtml(opt_data.item.suffix) : '') + ((opt_data.item.credentials) ? ', ' + soy.$$escapeHtml(opt_data.item.credentials) : '') + ((opt_data.item.specialty) ? '<span class="el8MRTagContainer"><span class="el8TagItem">' + soy.$$escapeHtml(opt_data.item.specialty) + '</span></span>' : ''), '</div>', (opt_data.item.is_org && opt_data.item.first_name && opt_data.item.last_name) ? '<div class="el8MRDetails">Primary Contact: ' + soy.$$escapeHtml(opt_data.item.first_name) + ((opt_data.item.middle_name) ? ' ' + soy.$$escapeHtml(opt_data.item.middle_name) : '') + ' ' + soy.$$escapeHtml(opt_data.item.last_name) + ((opt_data.item.suffix) ? ' ' + soy.$$escapeHtml(opt_data.item.suffix) : '') + ((opt_data.item.credentials) ? ', ' + soy.$$escapeHtml(opt_data.item.credentials) : '') + '</div>' : '');
  if (opt_data.item.npi || opt_data.item.license_numbers) {
    output.append('<div class="el8MRDetails">');
    if (opt_data.item.npi && opt_data.item.license_numbers) {
      output.append(' NPI: ', soy.$$escapeHtml(opt_data.item.npi), ',');
      var licenseList11570 = opt_data.item.license_numbers;
      var licenseListLen11570 = licenseList11570.length;
      for (var licenseIndex11570 = 0; licenseIndex11570 < licenseListLen11570; licenseIndex11570++) {
        var licenseData11570 = licenseList11570[licenseIndex11570];
        output.append(' ', soy.$$escapeHtml(licenseData11570.license_number_state), ' Lic #: ', soy.$$escapeHtml(licenseData11570.license_number), (! (licenseIndex11570 == licenseListLen11570 - 1)) ? ', ' : '');
      }
    } else if (opt_data.item.npi && ! opt_data.item.license_numbers) {
      output.append(' NPI: ', soy.$$escapeHtml(opt_data.item.npi));
    } else if (! opt_data.item.npi && opt_data.item.license_numbers) {
      var licenseList11583 = opt_data.item.license_numbers;
      var licenseListLen11583 = licenseList11583.length;
      for (var licenseIndex11583 = 0; licenseIndex11583 < licenseListLen11583; licenseIndex11583++) {
        var licenseData11583 = licenseList11583[licenseIndex11583];
        output.append(' ', soy.$$escapeHtml(licenseData11583.license_number_state), ' Lic #: ', soy.$$escapeHtml(licenseData11583.license_number), (! (licenseIndex11583 == licenseListLen11583 - 1)) ? ', ' : '');
      }
    }
    output.append('</div>');
  }
  output.append((opt_data.item.address || opt_data.item.suite || opt_data.item.city || opt_data.item.state || opt_data.item.zip) ? '<div class="el8MRDetails">' + ((opt_data.item.address) ? soy.$$escapeHtml(opt_data.item.address) : '') + ((opt_data.item.suite) ? ', ' + soy.$$escapeHtml(opt_data.item.suite) : '') + ((opt_data.item.city) ? ', ' + soy.$$escapeHtml(opt_data.item.city) : '') + ((opt_data.item.state) ? (opt_data.item.zip) ? ', ' + soy.$$escapeHtml(opt_data.item.state) + '  ' + soy.$$escapeHtml(opt_data.item.zip) : ', ' + soy.$$escapeHtml(opt_data.item.state) : '') + '</div>' : '', (opt_data.item.phone || opt_data.item.fax) ? '<div class="el8MRDetails">' + ((opt_data.item.phone && opt_data.item.fax) ? 'Office: ' + soy.$$escapeHtml(opt_data.item.phone) + ', Fax: ' + soy.$$escapeHtml(opt_data.item.fax) : (opt_data.item.phone && ! opt_data.item.fax) ? 'Office: ' + soy.$$escapeHtml(opt_data.item.phone) : (! opt_data.item.phone && opt_data.item.fax) ? 'Fax: ' + soy.$$escapeHtml(opt_data.item.fax) : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.insuranceCompany = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.carrier), ':<span class="el8MRDetails"> ', soy.$$escapeHtml(opt_data.item.address), (opt_data.item.suite) ? ' ' + soy.$$escapeHtml(opt_data.item.suite) : '', (opt_data.item.city) ? ' ' + soy.$$escapeHtml(opt_data.item.city) + ',' : '', (opt_data.item.state) ? ' ' + soy.$$escapeHtml(opt_data.item.state) : '', (opt_data.item.zip) ? ' ' + soy.$$escapeHtml(opt_data.item.zip) : '', (opt_data.item.phone) ? ' - ' + soy.$$escapeHtml(opt_data.item.phone) + ((opt_data.item.extension) ? soy.$$escapeHtml(opt_data.item.extension) : '') : '', '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.insurancePlan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.name), '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.insurancePlanWithCompany = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap"><div class=""><span class="el8Medium">', soy.$$escapeHtml(opt_data.item.carrier), '</span>', (opt_data.item.carrier != opt_data.item.name) ? ': ' + soy.$$escapeHtml(opt_data.item.name) : '', '</div><div class="el8MRDetails"> ', soy.$$escapeHtml(opt_data.item.address), (opt_data.item.suite) ? ' ' + soy.$$escapeHtml(opt_data.item.suite) : '', (opt_data.item.city) ? ' ' + soy.$$escapeHtml(opt_data.item.city) + ',' : '', (opt_data.item.state) ? ' ' + soy.$$escapeHtml(opt_data.item.state) : '', (opt_data.item.zip) ? ' ' + soy.$$escapeHtml(opt_data.item.zip) : '', (opt_data.item.phone) ? ' - ' + soy.$$escapeHtml(opt_data.item.phone) + ((opt_data.item.extension) ? soy.$$escapeHtml(opt_data.item.extension) : '') : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.referringProvider = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap"><div class="el8InlineBlock" style="width: 35px;">', (opt_data.item.public_access_user_id) ? '<img alt="" class="" src="/user/' + soy.$$escapeHtml(opt_data.item.public_access_user_id) + '/photo/profile/24/24/">' : (opt_data.item.is_org) ? '<img alt="" class="" src="/static/images/avatar_organization_sm.png">' : '<img alt="" class="" src="/static/images/user_photo_placeholder.png">', '</div><div class="el8MRDetails el8StandardFontSize el8InlineBlock el8VAlignTop" style="width: 385px;"><div class="el8Bold">', soy.$$escapeHtml(opt_data.item.reverse_name), (opt_data.item.practicing_status == 'retired') ? ' (retired)' : '');
  if (opt_data.item.specialties && opt_data.item.specialties.length) {
    output.append(' <span class="el8SmallFontSize el8NormalWeight">');
    el8.template.util.format.commaSeparate({list: opt_data.item.specialties}, output);
    output.append('</span>');
  }
  output.append('</div>', (opt_data.item.city || opt_data.item.state) ? '<div class="el8MRDetails"><span>' + ((opt_data.item.address) ? soy.$$escapeHtml(opt_data.item.address) : '') + ((opt_data.item.suite) ? ', ' + soy.$$escapeHtml(opt_data.item.suite) : '') + ((opt_data.item.city) ? ', ' + soy.$$escapeHtml(opt_data.item.city) : '') + ((opt_data.item.state) ? ', ' + soy.$$escapeHtml(opt_data.item.state) : '') + ((opt_data.item.zip) ? ', ' + soy.$$escapeHtml(opt_data.item.zip) : '') + '</span></div>' : '', (opt_data.item.phone) ? '<div><span class="el8MRDetails">Phone: ' + soy.$$escapeHtml(opt_data.item.phone) + '</span></div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.mindreader.rxSig = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MRItemWrap">', soy.$$escapeHtml(opt_data.item.sig), '<span class="el8MRTagContainer">', (opt_data.item.type == 'user') ? '<span class="el8TagItem mr5">User</span>' : '', '</span></div>');
  if (!opt_sb) return output.toString();
};
